import { B as BxfPopover$1, d as defineCustomElement$1 } from './p-17fd48bd.js';

const BxfPopover = BxfPopover$1;
const defineCustomElement = defineCustomElement$1;

export { BxfPopover, defineCustomElement };
